var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhoshortlistme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3639)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4819_3639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2377 50.9912C43.8173 50.9912 42.1723 50.5421 40.2823 49.6452C38.1735 48.6448 37.1527 48.6856 36.4848 48.7119C35.9408 48.7352 35.3793 48.7556 34.8223 48.1985C34.6268 48.0031 33.7387 46.9385 35.4843 45.1929C36.355 44.3223 37.5493 44.0715 38.5862 44.0569L32.54 38.0106C31.7131 37.1837 31.7145 35.8362 32.5443 35.0065C33.3727 34.1781 34.7202 34.1737 35.5485 35.0021L38.0627 37.5148C38.1618 37.3165 38.2945 37.1312 38.4593 36.9665C39.0354 36.389 39.8608 36.2125 40.5914 36.4371C40.6935 36.1483 40.8612 35.8771 41.0916 35.6467C41.4927 35.2456 42.0264 35.024 42.5923 35.0225H42.5966C43.1114 35.0225 43.597 35.2033 43.9806 35.5373C44.0798 35.3375 44.2139 35.1494 44.3802 34.9831C45.2085 34.1548 46.556 34.1519 47.3843 34.9787L51.3218 38.9177C53.7923 41.3881 53.5195 44.9669 50.6539 47.8354L49.0031 49.4862C47.9852 50.491 46.7368 50.9912 45.2377 50.9912ZM36.88 47.2433C37.6762 47.2433 38.9012 47.3746 40.9079 48.3283C45.2595 50.3933 47.0256 49.3885 47.9764 48.4523L49.6185 46.8102L49.62 46.8087C51.3583 45.0675 52.5745 42.234 50.3025 39.9619L46.3533 36.0127C46.0937 35.756 45.6723 35.7575 45.4127 36.0171C45.1531 36.2767 45.1502 36.6967 45.4068 36.9562L46.3927 37.9421C46.5356 38.085 46.6056 38.2717 46.6056 38.4583C46.6056 38.645 46.5341 38.8317 46.3927 38.9746C46.1083 39.259 45.646 39.259 45.3616 38.9746L43.0648 36.6777C42.9408 36.5537 42.7745 36.4852 42.5981 36.4852C42.391 36.4254 42.251 36.5537 42.1241 36.6821C41.8631 36.9431 41.8616 37.3646 42.1198 37.6242L43.7604 39.2648C43.9033 39.4077 43.9733 39.5944 43.9733 39.781C43.9733 39.9677 43.9018 40.1544 43.7604 40.2973C43.476 40.5817 43.0137 40.5817 42.7293 40.2973L40.4325 38.0004C40.1743 37.7408 39.7529 37.7452 39.4904 38.0033C39.2293 38.2644 39.2279 38.6858 39.486 38.9454L41.1266 40.586C41.2695 40.729 41.3395 40.9156 41.3395 41.1023C41.3395 41.289 41.2681 41.4756 41.1266 41.6185C40.8423 41.9029 40.38 41.9029 40.0956 41.6185L34.5175 36.0404C34.2593 35.7823 33.8364 35.7852 33.5754 36.0448C33.3143 36.3058 33.3129 36.7273 33.571 36.9869L41.1179 44.5337C41.3541 44.77 41.3993 45.1346 41.2287 45.4204C41.0581 45.7062 40.7125 45.8419 40.396 45.7485C40.3683 45.7412 37.7535 44.9917 36.5139 46.2312C35.9495 46.7956 35.8664 47.1427 35.881 47.2215C35.9423 47.2637 35.9554 47.2783 36.425 47.2608C36.562 47.2506 36.7123 47.2433 36.88 47.2433Z",
    fill: "#7F4F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 37.875H23.1042C22.7017 37.875 22.375 37.5483 22.375 37.1458C22.375 36.7433 22.7017 36.4167 23.1042 36.4167H28.9375C29.34 36.4167 29.6667 36.7433 29.6667 37.1458C29.6667 37.5483 29.34 37.875 28.9375 37.875Z",
    fill: "#7F4F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8833 42.25H23.1042C22.7017 42.25 22.375 41.9233 22.375 41.5208C22.375 41.1183 22.7017 40.7917 23.1042 40.7917H31.8833C32.2858 40.7917 32.6125 41.1183 32.6125 41.5208C32.6125 41.9233 32.2858 42.25 31.8833 42.25Z",
    fill: "#7F4F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3962 26.2083C28.7876 26.2083 27.4795 24.9002 27.4795 23.2917C27.4795 21.6831 28.7876 20.375 30.3962 20.375C32.0047 20.375 33.3128 21.6831 33.3128 23.2917C33.3128 24.9002 32.0047 26.2083 30.3962 26.2083Z",
    fill: "url(#paint1_linear_4819_3639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 33.5H25.2917C24.8892 33.5 24.5625 33.1733 24.5625 32.7708V31.3125C24.5625 29.3029 26.1988 27.6667 28.2083 27.6667H32.5833C34.5929 27.6667 36.2292 29.3029 36.2292 31.3125V32.7708C36.2292 33.1733 35.9025 33.5 35.5 33.5Z",
    fill: "url(#paint2_linear_4819_3639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8979 46.625H21.6458C19.6362 46.625 18 44.9888 18 42.9792V19.6458C18 17.6363 19.6362 16 21.6458 16H39.1458C41.1554 16 42.7917 17.6363 42.7917 19.6458V32.8C42.7917 33.2025 42.465 33.5292 42.0625 33.5292C41.66 33.5292 41.3333 33.2025 41.3333 32.8V19.6458C41.3333 18.4398 40.3519 17.4583 39.1458 17.4583H21.6458C20.4398 17.4583 19.4583 18.4398 19.4583 19.6458V42.9792C19.4583 44.1852 20.4398 45.1667 21.6458 45.1667H31.8979C32.3004 45.1667 32.6271 45.4933 32.6271 45.8958C32.6271 46.2983 32.3004 46.625 31.8979 46.625Z",
    fill: "#E60000",
    fillOpacity: 0.81
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3639",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_3639",
    x1: 30.3962,
    y1: 20.375,
    x2: 30.3962,
    y2: 26.2083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4819_3639",
    x1: 30.3958,
    y1: 27.6667,
    x2: 30.3958,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4819_3639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(18 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoshortlistme);
export default __webpack_public_path__ + "static/media/WHOSHORTLISTME.ff0ffda5a2d8f570d453ecb46e4a0044.svg";
export { ForwardRef as ReactComponent };